import Flex from '@Components/Bases/Flex';
import { FormInput, FormTextEditor } from '@Components/Form';
import { disabledFormInputStyles } from '@Components/Form/styles';
import { Box, InputLabel, styled } from '@mui/material';
import { useGreenhouseForm } from '../../EsgGreenhouseFormProvider';
import BoardResponsibilityRemark, {
  BOARD_RES_REMARK_ID,
} from './BoardResponsibilityRemark';

const LabelStyles = styled(InputLabel)({
  width: '100%',
  minWidth: 200,
  maxWidth: 350,
  textAlign: 'right',
  whiteSpace: 'inherit',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-end',
  '&& .MuiInputLabel-asterisk': {
    whiteSpace: 'nowrap',
  },
});

const ClimateChangeStructureBoardDirector = () => {
  const { control, watch } = useGreenhouseForm();

  const climateChangeStructure = watch('climateChangeStructure');
  const { isCompletedTh = false, isCompletedEn = false } =
    climateChangeStructure?.completedSection ?? {};

  return (
    <>
      <Flex gap={1} my={4}>
        <InputLabel required sx={{ fontWeight: 800 }}>
          บทบาทหน้าที่ของคณะกรรมการบริษัทในการกำกับดูแลด้านการเปลี่ยนแปลงสภาพภูมิอากาศ
        </InputLabel>
        <Flex gap={0.5} alignItems={'center'}>
          <BoardResponsibilityRemark />
        </Flex>
      </Flex>
      <FormTextEditor
        name="climateChangeStructure.boardResponsibility.descriptionTh"
        label={
          'อธิบายบทบาทในการกำกับดูแลด้านการเปลี่ยนแปลงสภาพภูมิอากาศของคณะกรรมการบริษัท (ไทย)'
        }
        inputProps={{ placeholder: 'กรุณาระบุ (ไทย)' }}
        required
        sx={isCompletedTh ? disabledFormInputStyles : undefined}
      />
      <Flex gap={3} my={6}>
        <LabelStyles>
          ลิงก์บทบาทในการกำกับดูแลด้านการเปลี่ยนแปลงสภาพภูมิอากาศของคณะกรรมการบริษัท
          (ไทย) (ถ้ามี)
        </LabelStyles>
        <Flex sx={{ width: '100%' }} gap={4}>
          <FormInput
            label={'ลิงก์'}
            name="climateChangeStructure.boardResponsibility.policyUrlTh"
            placeholder={'กรุณาระบุลิงก์'}
            control={control}
            sx={{
              width: 2 / 4,
              ...(isCompletedTh ? disabledFormInputStyles : {}),
            }}
          />
          <FormInput
            label="เลขหน้าของลิงก์"
            name="climateChangeStructure.boardResponsibility.policyPageTh"
            placeholder="กรุณาระบุเลขหน้า"
            sx={{
              width: 2 / 4,
              ...(isCompletedTh ? disabledFormInputStyles : {}),
            }}
          />
        </Flex>
      </Flex>
      <FormTextEditor
        name="climateChangeStructure.boardResponsibility.descriptionEn"
        label={
          'อธิบายบทบาทในการกำกับดูแลด้านการเปลี่ยนแปลงสภาพภูมิอากาศของคณะกรรมการบริษัท (อังกฤษ)'
        }
        inputProps={{ placeholder: 'กรุณาระบุ (อังกฤษ)' }}
        my={4}
        required
        sx={isCompletedEn ? disabledFormInputStyles : undefined}
      />
      <Flex gap={3} my={6}>
        <LabelStyles>
          ลิงก์บทบาทในการกำกับดูแลด้านการเปลี่ยนแปลงสภาพภูมิอากาศของคณะกรรมการบริษัท
          (อังกฤษ) (ถ้ามี)
        </LabelStyles>
        <Flex sx={{ width: '100%' }} gap={4}>
          <FormInput
            label={'ลิงก์'}
            name="climateChangeStructure.boardResponsibility.policyUrlEn"
            placeholder={'กรุณาระบุลิงก์'}
            control={control}
            sx={{
              width: 2 / 4,
              ...(isCompletedEn ? disabledFormInputStyles : undefined),
            }}
          />
          <FormInput
            label="เลขหน้าของลิงก์"
            name="climateChangeStructure.boardResponsibility.policyPageEn"
            placeholder="กรุณาระบุเลขหน้า"
            sx={{
              width: 2 / 4,
              ...(isCompletedEn ? disabledFormInputStyles : undefined),
            }}
          />
        </Flex>
      </Flex>
      <Box id={BOARD_RES_REMARK_ID} my={2} />
    </>
  );
};

export default ClimateChangeStructureBoardDirector;
